module.exports = __webpack_public_path__ + "static/img/product5.4b79c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/red/product5.png
// module id = ZlZD
// module chunks = 0